var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductLiabilityicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 66,
    viewBox: "0 0 71 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3972 20.419L9.84668 32.5078L14.9792 55.735L70.5297 43.6462L65.3972 20.419Z",
    fill: "#BADBAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6753 56.2081L9.37402 32.2122L65.6987 19.957L71.0001 43.953L14.6753 56.2081ZM10.3178 32.8122L15.2792 55.2715L70.0563 43.3537L65.0941 20.8944L10.3178 32.8122Z",
    fill: "#83B88E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7454 28.081C59.208 28.4529 58.1009 24.7113 58.0558 24.5516L57.9005 24.002L57.3386 24.1223L52.6594 25.1399L23.3999 31.5065L18.7214 32.5241L18.1604 32.6483L18.2515 33.2114C18.2785 33.3749 18.8498 37.233 14.5723 38.7798L14.0723 38.9607L14.7466 42.0103L15.4241 45.0772L16.0977 48.1269L16.6278 48.0836C21.1653 47.7124 22.2731 51.4541 22.3174 51.6129L22.472 52.1618L23.0338 52.0423L27.7123 51.0239L56.9725 44.6573L61.6518 43.6397L62.2128 43.5155L62.1217 42.9524C62.0955 42.7888 61.5242 38.9308 65.8017 37.384L66.3009 37.2031L65.6274 34.1535L64.9499 31.0866L64.2755 28.0369L63.7454 28.081ZM63.7612 31.3461L64.4387 34.413L64.888 36.4474C61.1842 38.0398 60.8498 41.2593 60.8784 42.5734L56.7126 43.4801L27.4516 49.8467L23.2858 50.7534C22.758 49.5487 21.0971 46.7625 17.0613 46.8545L16.612 44.8201L15.9345 41.7539L15.4852 39.7196C19.1897 38.1271 19.5234 34.9076 19.4948 33.5936L23.6606 32.6869L52.9216 26.3202L57.0874 25.4143C57.616 26.6191 59.2761 29.4052 63.3119 29.3132L63.7612 31.3461Z",
    fill: "#83B88E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3906 36.5147C48.2631 40.4631 45.7448 44.3652 41.766 45.231C37.7872 46.0968 33.8552 43.5977 32.9828 39.6492C32.1103 35.7007 34.6286 31.7987 38.6074 30.9328C42.5862 30.0678 46.5182 32.567 47.3906 36.5147Z",
    fill: "#83B88E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2761 35.4737C40.7333 35.1387 40.303 34.9688 39.6501 35.1112C38.9123 35.2716 38.5415 35.8299 38.6952 36.5259C39.0795 38.2662 42.3475 37.052 42.9172 39.6321C43.1692 40.7724 42.6185 41.7224 41.5044 42.1281L41.7722 43.3408L41.0471 43.4988L40.7848 42.3106C39.9948 42.4065 39.1358 42.1911 38.5248 41.834L38.8331 41.0492C39.4512 41.3803 40.1477 41.606 40.8855 41.4456C41.7801 41.2505 42.1193 40.6615 41.9553 39.9176C41.5258 37.9729 38.2443 39.1273 37.7277 36.787C37.4915 35.7191 38.0232 34.7982 39.0383 34.4011L38.7729 33.201L39.4979 33.043L39.7602 34.2312C40.5527 34.1463 41.143 34.4081 41.6787 34.7691L41.2761 35.4737Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1348 34.1323L51.4272 34.7119L51.012 34.2558L52.0833 33.2217L52.7513 33.0762L53.5794 36.8241L54.2958 36.7038L54.4226 37.2786L52.0508 37.7945L51.928 37.2393L52.573 37.0569C52.7014 37.0223 52.7585 36.9602 52.7212 36.7911L52.1348 34.1323Z",
    fill: "#83B88E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5106 34.2791C57.8649 35.8825 57.4568 36.687 56.4203 36.9127C55.3774 37.14 54.7015 36.5706 54.3536 34.9947C54.0097 33.4384 54.4971 32.6025 55.4717 32.3902C56.4258 32.1826 57.158 32.6835 57.5106 34.2791ZM56.7024 34.4694C56.4306 33.2387 56.0478 32.9603 55.5977 33.0578C55.1207 33.1616 54.9123 33.6114 55.1952 34.8893C55.4535 36.0595 55.8275 36.3615 56.2911 36.2608C56.7412 36.1625 56.9869 35.7551 56.7024 34.4694Z",
    fill: "#83B88E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1566 33.4881C61.5108 35.0916 61.1028 35.896 60.0663 36.1217C59.0234 36.349 58.3475 35.7797 57.9996 34.2037C57.6557 32.6475 58.143 31.8115 59.1177 31.5992C60.0718 31.3916 60.804 31.8917 61.1566 33.4881ZM60.3484 33.6784C60.0766 32.4469 59.693 32.1693 59.2437 32.2668C58.7667 32.3707 58.5583 32.8197 58.8412 34.0984C59.0995 35.2685 59.4735 35.5705 59.9371 35.469C60.3864 35.3715 60.6321 34.9634 60.3484 33.6784Z",
    fill: "#83B88E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1147 44.0493C24.575 44.3843 23.048 43.4139 22.7105 41.8859C22.3729 40.3579 23.3507 38.8426 24.8904 38.5076C26.4301 38.1726 27.9571 39.143 28.2947 40.6709C28.6323 42.1989 27.6544 43.7135 26.1147 44.0493ZM25.1511 39.6864C24.2668 39.879 23.705 40.7496 23.8991 41.6272C24.0932 42.5048 24.9705 43.0623 25.8548 42.8697C26.7391 42.677 27.301 41.8065 27.1076 40.9289C26.9127 40.0512 26.0355 39.4945 25.1511 39.6864Z",
    fill: "#83B88E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2596 0.554361L3.24707 35.043L17.8898 53.864L62.9024 19.3754L48.2596 0.554361Z",
    fill: "#BADBAC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8237 54.4151L2.69629 34.9708L48.3383 0L63.4657 19.4443L17.8237 54.4151ZM3.80726 35.1132L17.9671 53.3134L62.3539 19.3028L48.1949 1.10331L3.80726 35.1132Z",
    fill: "#83B88E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0714 8.17353C46.1299 10.4336 43.5173 7.52082 43.4079 7.39579L43.0315 6.96484L42.5751 7.31164L38.7833 10.2166L15.0724 28.3838L11.2815 31.2887L10.8274 31.6386L11.1523 32.1097C11.2466 32.2465 13.425 35.492 10.2244 38.7044L9.85034 39.0803L11.7735 41.5519L13.7071 44.0369L15.6303 46.5085L16.0907 46.2451C20.0322 43.985 22.6448 46.897 22.7542 47.022L23.1306 47.453L23.5862 47.1062L27.378 44.2012L51.0889 26.0333L54.8806 23.1283L55.3339 22.7784L55.009 22.3073C54.9147 22.1713 52.7363 18.9251 55.9377 15.7127L56.3117 15.3368L54.3885 12.8651L52.455 10.3801L50.5326 7.90851L50.0714 8.17353ZM51.4922 11.1186L53.4257 13.6036L54.7079 15.2518C52.0453 18.2629 53.1302 21.3149 53.7213 22.4906L50.3456 25.0778L26.6347 43.245L23.2582 45.8322C22.2621 44.9664 19.5607 43.1522 15.952 44.9475L14.6691 43.2993L12.7356 40.8143L11.4534 39.166C14.1167 36.1557 13.0319 33.1029 12.44 31.9273L15.8157 29.3408L39.5266 11.1728L42.9023 8.58638C43.8984 9.4522 46.5998 11.2656 50.2093 9.47107L51.4922 11.1186Z",
    fill: "#83B88E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.918 22.7352C41.4078 25.935 40.8118 30.5307 37.5875 33.0007C34.3639 35.4708 29.7322 34.8802 27.2432 31.6804C24.7542 28.4813 25.3493 23.8849 28.5737 21.4148C31.7972 18.9448 36.429 19.5353 38.918 22.7352Z",
    fill: "#83B88E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9422 24.3856C32.3075 24.3133 31.8447 24.3416 31.3154 24.7473C30.7179 25.2058 30.6228 25.8679 31.0618 26.4318C32.1585 27.8418 34.5905 25.3584 36.2165 27.4486C36.9353 28.3726 36.8465 29.4649 36.0145 30.3048L36.7792 31.287L36.1912 31.7376L35.4423 30.775C34.7696 31.1973 33.9003 31.3664 33.1942 31.3027L33.1348 30.4628C33.8361 30.4998 34.5628 30.4086 35.161 29.9509C35.8861 29.3957 35.9384 28.7186 35.4701 28.1162C34.2442 26.5403 31.7742 28.9758 30.2995 27.0798C29.626 26.214 29.7107 25.1563 30.4572 24.3667L29.7004 23.394L30.2884 22.9434L31.0373 23.9059C31.7172 23.4938 32.3638 23.4797 33.0041 23.5788L32.9422 24.3856Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1812 18.5681L41.7906 19.3922L41.2192 19.1563L41.7422 17.7668L42.2835 17.3516L44.6465 20.3886L45.2424 19.9765L45.6045 20.4421L43.6821 21.915L43.3326 21.4652L43.8366 21.0256C43.9372 20.9399 43.9634 20.8597 43.8564 20.722L42.1812 18.5681Z",
    fill: "#83B88E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1053 16.4222C48.1157 17.7213 48.0943 18.6217 47.2543 19.265C46.4096 19.9122 45.553 19.6849 44.5593 18.4078C43.5782 17.1464 43.6583 16.1847 44.4483 15.5792C45.2209 14.987 46.0989 15.1278 47.1053 16.4222ZM46.4563 16.9365C45.6805 15.9385 45.2138 15.8497 44.8493 16.1289C44.4626 16.4253 44.4681 16.9192 45.274 17.9556C46.0118 18.904 46.4793 19.0181 46.8557 18.7302C47.2202 18.4511 47.2662 17.9777 46.4563 16.9365Z",
    fill: "#83B88E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0594 14.1583C51.0698 15.4574 51.0484 16.3578 50.2084 17.0019C49.3629 17.6491 48.5071 17.4218 47.5134 16.1439C46.5324 14.8834 46.6124 13.9208 47.4024 13.3153C48.175 12.7231 49.053 12.8647 50.0594 14.1583ZM49.4104 14.6734C48.6339 13.6755 48.1679 13.5866 47.8034 13.8658C47.4167 14.1622 47.4222 14.6569 48.2281 15.6926C48.9659 16.6402 49.4334 16.755 49.8098 16.4671C50.1743 16.1872 50.2211 15.7146 49.4104 14.6734Z",
    fill: "#83B88E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9286 38.5724C21.6814 39.5278 19.8826 39.299 18.919 38.0612C17.9554 36.8234 18.1868 35.0383 19.4348 34.0821C20.6821 33.1266 22.4809 33.3562 23.4445 34.594C24.4081 35.8318 24.1759 37.6169 22.9286 38.5724ZM20.1781 35.0375C19.4618 35.5865 19.3287 36.6119 19.8818 37.3236C20.4349 38.0345 21.4674 38.1666 22.1845 37.6169C22.9009 37.068 23.034 36.0426 22.4809 35.3317C21.9278 34.62 20.8953 34.4886 20.1781 35.0375Z",
    fill: "#83B88E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0122 35.4023H9.71318L4.05447 42.5152C4.05447 42.5152 3.48868 56.4289 18.0114 64.8409L18.0122 35.4023Z",
    fill: "#B2B2B2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0122 35.4023H26.3113L31.97 42.5152C31.97 42.5152 32.5358 56.4289 18.0122 64.8409V35.4023Z",
    fill: "#9B9B9B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0123 37.5039H10.6063L6.23052 42.9009C6.23052 42.9009 5.27723 54.3854 18.0131 62.5206V37.5039H18.0123Z",
    fill: "#E84C43"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0122 37.5039H25.419L29.7948 42.9009C29.7948 42.9009 30.748 54.3854 18.0122 62.5206V37.5039Z",
    fill: "#D3362D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7641 65.2502C59.3147 65.2502 62.1931 62.3938 62.1931 58.8702C62.1931 55.3467 59.3147 52.4902 55.7641 52.4902C52.2135 52.4902 49.3352 55.3467 49.3352 58.8702C49.3352 62.3938 52.2135 65.2502 55.7641 65.2502Z",
    fill: "#F9B256"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7641 64.1186C58.6841 64.1186 61.0512 61.7695 61.0512 58.8718C61.0512 55.9741 58.6841 53.625 55.7641 53.625C52.8441 53.625 50.4771 55.9741 50.4771 58.8718C50.4771 61.7695 52.8441 64.1186 55.7641 64.1186Z",
    fill: "#FFE167"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7642 64.3145C52.7395 64.3145 50.2791 61.8728 50.2791 58.8711C50.2791 55.8695 52.7395 53.4277 55.7642 53.4277C58.7889 53.4277 61.2494 55.8695 61.2494 58.8711C61.2494 61.8728 58.7889 64.3145 55.7642 64.3145ZM55.7642 53.8209C52.9582 53.8209 50.6753 56.0865 50.6753 58.8711C50.6753 61.6557 52.9582 63.9213 55.7642 63.9213C58.5702 63.9213 60.8532 61.6557 60.8532 58.8711C60.8532 56.0865 58.5702 53.8209 55.7642 53.8209Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6151 56.9716L54.5128 57.5323L54.0984 56.812L55.8132 55.7559H56.7364V60.9342L57.7158 60.9814V61.7757H54.4376V61.009L55.3417 60.9531C55.5208 60.9437 55.6151 60.8784 55.6151 60.6441V56.9716Z",
    fill: "#FBCB43"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2009 63.4316H41.1787V65.5407H42.2009V63.4316Z",
    fill: "#F9B256"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0638 63.4316H35.0408V65.5407H36.0638V63.4316Z",
    fill: "#F9B256"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1558 63.4316H39.1328V65.5407H40.1558V63.4316Z",
    fill: "#F9B256"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1097 63.4316H37.0867V65.5407H38.1097V63.4316Z",
    fill: "#F9B256"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2471 63.4316H43.2241V65.5407H44.2471V63.4316Z",
    fill: "#F9B256"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0184 63.4316H32.9954V65.5407H34.0184V63.4316Z",
    fill: "#F9B256"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9954 63.4316H31.9724V65.5407H32.9954V63.4316Z",
    fill: "#FFE167"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0408 63.4316H34.0186V65.5407H35.0408V63.4316Z",
    fill: "#FFE167"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0867 63.4316H36.0637V65.5407H37.0867V63.4316Z",
    fill: "#FFE167"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1326 63.4316H38.1096V65.5407H39.1326V63.4316Z",
    fill: "#FFE167"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1788 63.4316H40.1558V65.5407H41.1788V63.4316Z",
    fill: "#FFE167"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2239 63.4316H42.2009V65.5407H43.2239V63.4316Z",
    fill: "#FFE167"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2701 63.4316H44.2471V65.5407H45.2701V63.4316Z",
    fill: "#FFE167"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2701 63.4303V65.5394H31.9717V63.4303H45.2701ZM45.6663 63.0371H45.2701H31.9717H31.5754V63.4303V65.5394V65.9326H31.9717H45.2701H45.6663V65.5394V63.4303V63.0371Z",
    fill: "#F5B400"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7359 60.9062H42.7129V63.0154H43.7359V60.9062Z",
    fill: "#F9B256"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5987 60.9062H36.5757V63.0154H37.5987V60.9062Z",
    fill: "#F9B256"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M41.69 60.9062H40.667V63.0154H41.69V60.9062Z",
    fill: "#F9B256"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6439 60.9062H38.6208V63.0154H39.6439V60.9062Z",
    fill: "#F9B256"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7821 60.9062H44.759V63.0154H45.7821V60.9062Z",
    fill: "#F9B256"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5526 60.9062H34.5295V63.0154H35.5526V60.9062Z",
    fill: "#F9B256"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5288 60.9062H33.5066V63.0154H34.5288V60.9062Z",
    fill: "#FFE167"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5758 60.9062H35.5527V63.0154H36.5758V60.9062Z",
    fill: "#FFE167"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6209 60.9062H37.5986V63.0154H38.6209V60.9062Z",
    fill: "#FFE167"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6671 60.9062H39.644V63.0154H40.6671V60.9062Z",
    fill: "#FFE167"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M42.713 60.9062H41.6899V63.0154H42.713V60.9062Z",
    fill: "#FFE167"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7591 60.9062H43.7361V63.0154H44.7591V60.9062Z",
    fill: "#FFE167"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8042 60.9062H45.782V63.0154H46.8042V60.9062Z",
    fill: "#FFE167"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8042 60.9049V63.014H33.5066V60.9049H46.8042ZM47.2004 60.5117H46.8042H33.5066H33.1104V60.9049V63.014V63.4072H33.5066H46.8042H47.2004V63.014V60.9049V60.5117Z",
    fill: "#F5B400"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7359 53.248H42.7129V55.3571H43.7359V53.248Z",
    fill: "#F9B256"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5987 53.248H36.5757V55.3571H37.5987V53.248Z",
    fill: "#F9B256"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M41.69 53.248H40.667V55.3571H41.69V53.248Z",
    fill: "#F9B256"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6439 53.248H38.6208V55.3571H39.6439V53.248Z",
    fill: "#F9B256"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7821 53.248H44.759V55.3571H45.7821V53.248Z",
    fill: "#F9B256"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5526 53.248H34.5295V55.3571H35.5526V53.248Z",
    fill: "#F9B256"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5288 53.248H33.5066V55.3571H34.5288V53.248Z",
    fill: "#FFE167"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5758 53.248H35.5527V55.3571H36.5758V53.248Z",
    fill: "#FFE167"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6209 53.248H37.5986V55.3571H38.6209V53.248Z",
    fill: "#FFE167"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6671 53.248H39.644V55.3571H40.6671V53.248Z",
    fill: "#FFE167"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M42.713 53.248H41.6899V55.3571H42.713V53.248Z",
    fill: "#FFE167"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7591 53.248H43.7361V55.3571H44.7591V53.248Z",
    fill: "#FFE167"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8042 53.248H45.782V55.3571H46.8042V53.248Z",
    fill: "#FFE167"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8042 53.2487V55.3578H33.5066V53.2487H46.8042ZM47.2004 52.8555H46.8042H33.5066H33.1104V53.2487V55.3578V55.751H33.5066H46.8042H47.2004V55.3578V53.2487V52.8555Z",
    fill: "#F5B400"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2952 58.3809H40.2722V60.49H41.2952V58.3809Z",
    fill: "#F9B256"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M35.158 58.3809H34.135V60.49H35.158V58.3809Z",
    fill: "#F9B256"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2501 58.3809H38.2271V60.49H39.2501V58.3809Z",
    fill: "#F9B256"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2039 58.3809H36.1809V60.49H37.2039V58.3809Z",
    fill: "#F9B256"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3403 58.3809H42.3181V60.49H43.3403V58.3809Z",
    fill: "#F9B256"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1119 58.3809H32.0889V60.49H33.1119V58.3809Z",
    fill: "#F9B256"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0889 58.3809H31.0667V60.49H32.0889V58.3809Z",
    fill: "#FFE167"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1348 58.3809H33.1118V60.49H34.1348V58.3809Z",
    fill: "#FFE167"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M36.181 58.3809H35.158V60.49H36.181V58.3809Z",
    fill: "#FFE167"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2269 58.3809H37.2039V60.49H38.2269V58.3809Z",
    fill: "#FFE167"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M40.273 58.3809H39.25V60.49H40.273V58.3809Z",
    fill: "#FFE167"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3182 58.3809H41.2952V60.49H42.3182V58.3809Z",
    fill: "#FFE167"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3643 58.3809H43.3413V60.49H44.3643V58.3809Z",
    fill: "#FFE167"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3643 58.3795V60.4886H31.0666V58.3795H44.3643ZM44.7605 57.9863H44.3643H31.0666H30.6704V58.3795V60.4886V60.8818H31.0666H44.3643H44.7605V60.4886V58.3795V57.9863Z",
    fill: "#F5B400"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2952 55.8027H40.2722V57.9118H41.2952V55.8027Z",
    fill: "#F9B256"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M35.158 55.8027H34.135V57.9118H35.158V55.8027Z",
    fill: "#F9B256"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2501 55.8027H38.2271V57.9118H39.2501V55.8027Z",
    fill: "#F9B256"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2039 55.8027H36.1809V57.9118H37.2039V55.8027Z",
    fill: "#F9B256"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3403 55.8027H42.3181V57.9118H43.3403V55.8027Z",
    fill: "#F9B256"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1119 55.8027H32.0889V57.9118H33.1119V55.8027Z",
    fill: "#F9B256"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0889 55.8027H31.0667V57.9118H32.0889V55.8027Z",
    fill: "#FFE167"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1348 55.8027H33.1118V57.9118H34.1348V55.8027Z",
    fill: "#FFE167"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M36.181 55.8027H35.158V57.9118H36.181V55.8027Z",
    fill: "#FFE167"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2269 55.8027H37.2039V57.9118H38.2269V55.8027Z",
    fill: "#FFE167"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M40.273 55.8027H39.25V57.9118H40.273V55.8027Z",
    fill: "#FFE167"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3182 55.8027H41.2952V57.9118H42.3182V55.8027Z",
    fill: "#FFE167"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3643 55.8027H43.3413V57.9118H44.3643V55.8027Z",
    fill: "#FFE167"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3643 55.8014V57.9105H31.0666V55.8014H44.3643ZM44.7605 55.4082H44.3643H31.0666H30.6704V55.8014V57.9105V58.3037H31.0666H44.3643H44.7605V57.9105V55.8014V55.4082Z",
    fill: "#F5B400"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2141 43.5559C14.2141 43.5559 12.8947 43.1777 12.0873 42.2647C11.4692 41.5656 11.0333 40.1367 11.0317 40.1406C11.031 40.1367 10.5943 41.5656 9.97624 42.2647C9.16876 43.1777 7.84937 43.5559 7.84937 43.5559C7.84937 43.5559 9.13627 44.0112 9.8653 44.8094C10.5967 45.61 11.0357 46.8501 11.0357 46.8525C11.0357 46.8525 11.466 45.61 12.1966 44.8094C12.9272 44.0112 14.2141 43.5559 14.2141 43.5559Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLiabilityicon);
export default __webpack_public_path__ + "static/media/Product Liability icon.1c7bbf4e9dcfe27f51bafbfe676ea62f.svg";
export { ForwardRef as ReactComponent };